import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowCornerLeftUp: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-corner-left-up"><path d="M19.25 20.25H8.75V4.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 7.75L8.75 3.75L4.75 7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowCornerLeftUp;
